/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RedeemRewardRequest } from '../../models/redeem-reward-request';
import { RedeemRewardResult } from '../../models/redeem-reward-result';

export interface PostRedeemReward$Params {
  body?: RedeemRewardRequest;
}

export function postRedeemReward(
  http: HttpClient,
  rootUrl: string,
  params?: PostRedeemReward$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RedeemRewardResult>> {
  const rb = new RequestBuilder(rootUrl, postRedeemReward.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RedeemRewardResult>;
    }),
  );
}

postRedeemReward.PATH = '/Loyalty/redeem-reward';
